import React, { useEffect } from 'react';
import { Advertorial } from './pages/Advertorial';
export function App() {
  useEffect(() => {
    const win = window as any;
    if (win.fbq) return;
    const n = win.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!win._fbq) win._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    win.fbq('init', '932263746333538');
    win.fbq('track', 'PageView');
  }, []);
  return <Advertorial data-id="element-0" data-mp="31c1j8fbfw0hu" />;
}